import React from 'react';
import { AperturaStore } from '../../stores';
import { ConsultaStore } from '../../stores/consultaStore';
import { inject, observer } from 'mobx-react';
import { List, Col, DatePicker, Row, Button } from 'antd';
import { ConsultaApertura } from '../../models';
import styled from 'styled-components';
import moment from 'moment';
import { RangePickerValue } from 'antd/lib/date-picker/interface';

interface AperturasTablesProps {
    aperturaStore?: AperturaStore;
    consultaStore?: ConsultaStore;
}

const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 0 150px;
    max-width: 1600px;
`;

const ColStyled = styled(Col)`
    text-align: center;
    font-weight: bold !important;
`;

@inject('aperturaStore')
@inject('consultaStore')
@observer
export class AperturasTables extends React.Component<AperturasTablesProps> {
    onCalendarRangeChange = (
        dates: RangePickerValue,
        dateStrings: [string, string],
        mes: number
    ) => {
        const { aperturaStore } = this.props;
        aperturaStore!.listaAperturas!.forEach(a => {
            if (a.mes == mes) {
                a.fechaInicio = dateStrings[0];
                a.fechaFin = dateStrings[1];
            }
        });
    };

    renderHeader() {
        return (
            <>
                <ColStyled span={6}>Mes</ColStyled>
                <ColStyled span={10}>Vigencia</ColStyled>
                <br />
            </>
        );
    }
    renderFooter() {
        const stylePrimary = {
            backgroundColor: '#a8123e',
            borderColor: '#a8123e',
            color: '#fff',
            marginRight: '10px'
        };
        const styleVeda = {
            backgroundColor: '#3c3c3b',
            borderColor: '#3c3c3b',
            color: '#fff',
            marginRight: '10px'
        };
        return (
            <>
                <Row style={{ textAlign: 'right' }}>
                    <Button style={stylePrimary} onClick={this.clickGuardar}>
                        Guardar
                    </Button>
                </Row>
            </>
        );
    }

    clickGuardar = async () => {
        const { aperturaStore } = this.props;
        await aperturaStore!.insertarAperturas();
    };

    renderItem(item: ConsultaApertura) {
        const dateFormat = 'DD/MM/YYYY';
        return (
            <>
                <List.Item key={item.id}>
                    {
                        <>
                            <Col span={8}>{item.mesString}</Col>
                            <Col span={8}>
                                <DatePicker.RangePicker
                                    id={item.mes}
                                    format={dateFormat}
                                    defaultValue={[
                                        moment(item.fechaInicio, dateFormat),
                                        moment(item.fechaFin, dateFormat)
                                    ]}
                                    onChange={(date, dateString) =>
                                        this.onCalendarRangeChange(date, dateString, item.mes)
                                    }
                                    allowClear={false}
                                />
                            </Col>
                        </>
                    }
                </List.Item>
            </>
        );
    }

    render() {
        const { aperturaStore } = this.props;
        return (
            <>
                <ConsultasWrapper>
                    <List
                        loading={aperturaStore!.cargando}
                        header={this.renderHeader()}
                        footer={this.renderFooter()}
                        dataSource={aperturaStore!.listaAperturas}
                        renderItem={(item: ConsultaApertura) => this.renderItem(item)}
                    />
                </ConsultasWrapper>
            </>
        );
    }
}
